import { render, staticRenderFns } from "./ku-article-create.vue?vue&type=template&id=d9c92338"
import script from "./ku-article-create.vue?vue&type=script&lang=js"
export * from "./ku-article-create.vue?vue&type=script&lang=js"
import style0 from "./ku-article-create.vue?vue&type=style&index=0&id=d9c92338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports